import React, { useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { Box, Typography, Paper, Divider } from "@material-ui/core";
import { APIError } from "../../components/APIError";

import { ActivityList } from "./components/ActivityList";
import { ActivityLoader } from "./components/ActivityLoader";
import { useAccountActivities } from "../../api/hooks/useAccountActivities";
import { PageLink } from "../../components/CustomLink";
import { PAGE_SIZE } from "../../hooks/usePagination";

const ViewOlderLink: React.FC<{
  url: string;
}> = ({ url }) => (
  <>
    <Divider />
    <Box display="flex" alignItems="center" flexDirection="column" py={1.5}>
      <PageLink path={`${url}/activities/2`} text="View older activities" />
    </Box>
  </>
);

export const ActivityContainer: React.FC<{
  accountNumber: string;
}> = ({ accountNumber }) => {
  const { url } = useRouteMatch();

  const { status, data, error, setPage } = useAccountActivities(accountNumber);
  const activities = data || [];
  useEffect(() => setPage(1), [setPage]);
  return (
    <Box width={286}>
      <Box
        mb={1.5}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="overline" data-testid="ActivityPanel__Heading">
          Latest Activity
        </Typography>
        {status === "success" && activities.length > 0 && (
          <PageLink path={`${url}/activities`} text="View all" />
        )}
      </Box>
      {error ? (
        <APIError
          title="We could not load latest activities for this account."
          messages={[(error as Error).message]}
        />
      ) : status === "success" && activities.length === 0 ? (
        <Typography variant="body1">No activities for this account.</Typography>
      ) : (
        <Paper elevation={1}>
          {status === "loading" ? (
            <Box clone p={2}>
              <ActivityLoader />
            </Box>
          ) : (
            <>
              <ActivityList activities={activities} />
              {activities.length === PAGE_SIZE && <ViewOlderLink url={url} />}
            </>
          )}
        </Paper>
      )}
    </Box>
  );
};
